import React from "react";

import { templates } from "@reactivated";

import { RetailCardsSSR } from "../apps/retail/RetailCardsSSR";

/** @public */
export const Template = (
    props: templates.RetailCardsBlockTemplate,
): React.JSX.Element => {
    return <RetailCardsSSR {...props} />;
};
